<template>
  <div :class="$vuetify.breakpoint.mdAndDown ? 'pt-0 pb-4' : 'py-4'" v-if="matchesHighlights.length > 0">
    <v-row no-gutters class="font-weight-bold" align="end">
      <v-col cols="12">
        {{ $t(`label.upComingMatches`) }}
      </v-col>
    </v-row>
    <v-row no-gutters justify="center" class="mx-0">
      <!-- desktop view-->
      <div  class="arrow left-arrow hidden-sm-and-down" @mousedown="startScrollingLeft"
           @mouseup="stopScrolling"
           @mouseleave="stopScrolling">
        <v-icon>mdi-chevron-left</v-icon>
      </div>
      <v-col class="pt-2 highlights-container hidden-sm-and-down">
        <div class="matches-box">
          <div class="match-item" v-for="(league, index) in matchesHighlights" :key="index" @click="goToCricketPage">
            <v-row no-gutters class="flex-nowrap">
              <v-col cols="12">
                <v-row no-gutters>
                  <v-col>
                    <v-card class="pa-2 font-weight-bold cricket-name-header">
                      {{ league.league_name + ' ' + league.matchDate }}
                    </v-card>
                  </v-col>
                </v-row>
                <v-row no-gutters class="cricket-name-content">
                  <v-col cols="12">
                    <v-card
                        light
                        class="pa-2 mb-1 mr-1 grey lighten-4 cricket-name-card"
                        outlined
                        tile
                    >
                      <img :src="league.home_logo" height="30" width="30"/>
                      {{ league.home_team }}
                    </v-card>
                  </v-col>
                  <v-col cols="12">
                    <v-card
                        light
                        class="pa-2 mb-1 mr-1 grey lighten-4 cricket-name-card"
                        outlined
                        tile
                    >
                      <img :src="league.away_logo" height="30" width="30"/>
                      {{ league.away_team }}
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </div>
        </div>
      </v-col>
      <div  class="arrow right-arrow hidden-sm-and-down"  @mousedown="startScrollingRight"
           @mouseup="stopScrolling"
           @mouseleave="stopScrolling">
        <v-icon>mdi-chevron-right</v-icon>
      </div>
      <!-- mobile view -->
      <v-col cols="12" class="pt-2 highlights-container hidden-md-and-up">
        <div class="matches-box">
          <div class="match-item" v-for="(league, index) in matchesHighlights" :key="index">
            <!-- <v-img width="200" height="200" class="game-card-image-avatar" src="https://cdn.pixabay.com/photo/2020/07/12/07/47/bee-5396362_1280.jpg" alt/> -->
            <v-row no-gutters class="flex-nowrap">
              <v-col cols="12">
                <v-card class="mobile-match-card" dark>
                  <v-row>
                    <v-col cols="12" class="font-weight-bold cricket-name-header">
                      {{ league.league_name }}
                    </v-col>
                  </v-row>
                  <v-row class="mobile-detail-wrapper no-gutters">
                    <v-col cols="4" class="mobile-match-details">
                      <span class="team-title">{{ league.home_team }}</span>
                    </v-col>
                    <v-col cols="4" class="mobile-match-details match-date">
                      <span>{{ league.mobileMatchDate }}</span>
                      <span class="match-time">{{ league.mobileMatchTime }}</span>
                    </v-col>
                    <v-col cols="4" class="mobile-match-details">
                      <span class="team-title">{{ league.away_team }}</span>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import stingFormat from 'string-format'
import {formValidator, uiHelper} from '@/util'
import {SHARED} from '@/constants/constants'
import {GAME_MATCHES_HIGHLIGHTS} from '@/store/game.module'
import {ROUTE_NAME} from '@/constants/route.constants'
import {locale} from '@/util/localization-helper'
import {orderBy, take} from "lodash";

export default {
  name: 'appHomeHighlight',
  data: () => ({
    highlights: null,
    routeName: ROUTE_NAME,
    desktopHighlights_1: [],
    desktopHighlights_2: [],
    currentHightlight_1: 0,
    currentHightlight_2: 0,
    startTime: SHARED.DEFAULT_START_TIME,
    endTime: SHARED.DEFAULT_END_TIME,
    scrollInterval: null
  }),
  created() {
    this.getMatchesHighlights()
  },
  computed: {
    matchesHighlights() {
      let k = this.$store.state.game.matchesHighlights.filter(x => x.match_date >= this.startTime)
      k = orderBy(k, ['match_date'], ['asc'])
      k = take(k, 7)
      const n = Math.ceil(k.length / 2)
      this.desktopHighlights_1 = k.slice(0, n)
      this.desktopHighlights_2 = k.slice(n)
      k = k.map(function(league) {
        let leagueTime = league.match_date.indexOf(' ') != -1 ? league.match_date.split(' ')[1] : league.match_date
        let leagueDate = league.match_date.indexOf(' ') != -1 ? league.match_date.split(' ')[0] : league.match_date

        league.mobileMatchTime = leagueTime.split(':')[0] + ':' + leagueTime.split(':')[1]
        league.mobileMatchDate = leagueDate.split('-').reverse().join('-');


        let dateObject = new Date(league.match_date.replace(" ", "T"));
        let formattedDate = dateObject.getFullYear() + " · " +
            ("0" + (dateObject.getMonth() + 1)).slice(-2) + "/" +
            ("0" + dateObject.getDate()).slice(-2) + ", " +
            (dateObject.getHours() % 12 || 12) + ":" +
            ("0" + dateObject.getMinutes()).slice(-2) +
            (dateObject.getHours() >= 12 ? "PM" : "AM");

        league.matchDate = formattedDate;

        return league
      })
      return k
    }
  },
  /*watch: {
    matchesHighlights() {
      this.highlights = this.$store.state.game.matchesHighlights
      return this.highlights
    }
  },*/
  methods: {
    changeLanguage(language) {
      this.$store.dispatch(`${SHARED.LOADING}`)
      uiHelper.removeCookie('language')
      uiHelper.setCookie('language', language)
      window.location.reload()
    },
    getMatchesHighlights() {
      this.$store.dispatch(`${GAME_MATCHES_HIGHLIGHTS}`)
    },
    goToCricketPage() {
      this.$router.push({
        name: ROUTE_NAME.CRICKET,
        params: { lang: this.$route.params.lang }
      })
    },
    scrollLeft() {
      const container = this.$el.querySelector('.highlights-container');
      container.scrollLeft -= 10;
    },
    scrollRight() {
      const container = this.$el.querySelector('.highlights-container');
      container.scrollLeft += 10;
    },
    startScrollingLeft() {
      this.scrollInterval = setInterval(this.scrollLeft, 20);
    },
    startScrollingRight() {
      this.scrollInterval = setInterval(this.scrollRight, 20);
    },
    stopScrolling() {
      clearInterval(this.scrollInterval);
      this.scrollInterval = null;
    }
  }
}
</script>

<style lang="scss">
.highlights-container {
  width: 100%;
  overflow-x: scroll;
  overflow-y: hidden;
  white-space: nowrap;
  max-width: 100vw;

  .border-top-left-radius {
    border-top-left-radius: 10px !important;
  }

  .border-top-right-radius {
    border-top-right-radius: 10px !important;
  }

  .border-bottom-left-radius {
    border-bottom-left-radius: 10px !important;
  }

  .border-bottom-right-radius {
    border-bottom-right-radius: 10px !important;
  }
}

.arrow {
  width: 30px;
  height: 30px;
  place-self: center;
  align-content: center;
  border-radius: 16px;
  background-color: #FD8839;
  i {
    font-size: 28px !important;
    color: white !important;
  }
}

.left-arrow {
  margin-right: 8px;
}

.right-arrow {
  margin-left: 8px;
}

.matches-box {
  margin-bottom: 5px;

  .match-item {
    display: inline-block;
    width: 360px; // padding-right: 20px;
    margin: 0 15px 0 0;
    cursor: pointer;
  }

  .mobile-match-card {
    &.v-card {
      text-overflow: ellipsis;
      overflow: hidden;
      width: auto;
      white-space: nowrap;
      background-color: #1d1d1d;
      border-radius: 15px;
      color: #ffffff;
    }
  }

  .mobile-detail-wrapper {
    background-color: white;
    height: auto;
    min-height: 120px;
    display: flex;
    align-items: center;
    border: 1px solid #00000030;
    box-shadow: 0px 2px 4px 0px #00000040;


    .mobile-match-details {
      font-size: 14px;
      font-weight: bold;
      color: black;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .team-title {
      white-space: break-spaces;
      overflow: hidden;
      padding: 0 5px 0 5px;
      text-align: center;
    }

    .match-date {
      font-size: 14px;
      font-weight: bold;
      white-space: pre-line;
      text-overflow: ellipsis;
      text-align: center;
      align-items: unset;
      color: black;
      height: 78px;
      flex-direction: column;

      .match-time {
        font-size: 18px;
      }
    }
  }
}

.cricket-name-header {
  font-size: 14px;
  border-top-left-radius: 12px !important;
  border-top-right-radius: 12px !important;
  color: white !important;
  background: linear-gradient(180deg, #EC2227 0%, #861316 100%);
}

.cricket-name-content {
  border-bottom-left-radius: 12px !important;
  border-bottom-right-radius: 12px !important;
  border: 1px solid #00000030;
  box-shadow: 2px 2px 10px 0px #00000040;

  img {
    margin-right: 12px;
  }

  .cricket-name-card {
    display: flex;
    align-items: center;
    font-size: 14px;
  }
}

@media (max-width: 599px) {
  .highlights-container {
    font-size: 14px;
  }

  .matches-box {
    .match-item {
      width: 300px;
    }
  }
}

.cricket-name-header {
  height: 40px;
  padding-left: 20px;
  padding-top: 16px;
}
</style>
